// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.font-weight-bold {
  font-weight: bold;
}

/* Loading spinner animation */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.loading-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  opacity: 0.5;
}

.loading {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007aff;
  animation: spin 1s linear infinite;
}

.bg-container {
  position: fixed;
  min-width: 100%;
  min-height: 100%;
}

.bg-container img {
  position: absolute;
  /*z-index: 1;*/
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.form-auth-wrapper {
  max-width: 440px;
  margin: 0 auto;
  min-height: 50vh;
}
.form-auth-wrapper .title {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 20px;
}
@media (max-width: 991px) {
  .form-auth-wrapper .title {
    font-size: 24px;
  }
}
.form-auth-wrapper label {
  font-size: 18px;
  font-weight: 600;
}
@media (max-width: 991px) {
  .form-auth-wrapper label {
    font-size: 16px;
  }
}
.form-auth-wrapper input {
  border: 1px solid white;
  border-radius: 4px;
  background-color: transparent;
  color: white;
  padding: 10px 20px;
}
.form-auth-wrapper input:focus {
  background-color: transparent;
  border: 1px solid white;
  caret-color: white;
}
.form-auth-wrapper .form-control {
  color: white;
}
.form-auth-wrapper .form-auth-checkbox input[type=checkbox] {
  border-radius: 0;
  padding: 4px;
}
.form-auth-wrapper .form-auth-checkbox input[type=checkbox]:checked {
  background-color: transparent;
  border-color: orange;
}
.form-auth-wrapper .form-auth-checkbox label {
  font-size: 14px;
  font-weight: 400;
  color: #9e9e9e;
}
.form-auth-wrapper a {
  color: rgba(1, 157, 209, 0.9019607843);
  transition: 0.2s ease-in-out;
}
.form-auth-wrapper a:hover {
  color: orange;
}
.form-auth-wrapper .form-auth-btn {
  width: 100%;
  color: white;
  padding: 10px 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
  background-color: #019dd1;
  transition: 0.2s ease-in-out;
}
@media (max-width: 991px) {
  .form-auth-wrapper .form-auth-btn {
    font-size: 16px;
  }
}
.form-auth-wrapper .form-auth-btn:hover {
  background-color: orange;
}

.not_found_container {
  padding-top: 50px;
  justify-content: center;
  display: grid;
}

.profile-container {
  padding: 20px;
}
.profile-container .title {
  font-weight: bolder;
  border-bottom-width: 1px;
}
.profile-container .text-right {
  text-align: end;
  margin-right: 20px;
}
.profile-container .content-card {
  font-weight: 500;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .profile-container .avatar-dimension {
    width: 70px;
    height: 70px;
  }
}
@media only screen and (max-width: 767px) {
  .profile-container .avatar-dimension {
    width: 70px;
    height: 70px;
    margin-bottom: 10px;
  }
}

.mt-5 {
  margin-top: 3rem;
}

.text-center {
  text-align: center;
}

.mfa-title {
  font-size: 30px;
  font-weight: bold;
  margin: 0 16px 24px;
}

.mr-2 {
  margin-right: 0.5rem;
}

.custom-checkbox-container {
  padding: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
.custom-checkbox-container .ant-checkbox-group {
  flex-direction: column;
  gap: 10px;
}

.custom-modal-width {
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.custom-modal-width .ant-modal-content {
  width: 800px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/base.scss","webpack://./src/assets/scss/style.scss","webpack://./src/assets/scss/components/_loading.scss","webpack://./src/assets/scss/components/_background.scss","webpack://./src/assets/scss/components/_form-auth.scss","webpack://./src/assets/scss/pages/_not-found.scss","webpack://./src/assets/scss/pages/_profile.scss","webpack://./src/assets/scss/custom.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;ACDF;;ADIA;EACE,+EAAA;ACDF;;ADKA;EACE,iBAAA;ACFF;;ACbA,8BAAA;AACA;EACE;IACE,yBAAA;EDgBF;AACF;ACbA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;ADeF;;ACZA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,kCAAA;ADeF;;AE1CA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AF6CF;;AE3CA;EACE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AF8CF;;AGzDA;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;AH4DJ;AG1DI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AH4DR;AG1DQ;EALJ;IAMQ,eAAA;EH6DV;AACF;AG1DI;EACI,eAAA;EACA,gBAAA;AH4DR;AG1DQ;EAJJ;IAKQ,eAAA;EH6DV;AACF;AG1DI;EACI,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;AH4DR;AG1DQ;EACI,6BAAA;EACA,uBAAA;EACA,kBAAA;AH4DZ;AGxDI;EACI,YAAA;AH0DR;AGtDQ;EACI,gBAAA;EACA,YAAA;AHwDZ;AGtDY;EACI,6BAAA;EACA,oBAAA;AHwDhB;AGpDQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AHsDZ;AGlDI;EACI,sCAAA;EACA,4BAAA;AHoDR;AGlDQ;EACI,aAAA;AHoDZ;AGhDI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,4BAAA;AHkDR;AGhDQ;EAVJ;IAWQ,eAAA;EHmDV;AACF;AGjDQ;EACI,wBAAA;AHmDZ;;AIvIA;EACE,iBAAA;EACA,uBAAA;EACA,aAAA;AJ0IF;;AK3IA;EACE,aAAA;AL8IF;AK7IE;EACE,mBAAA;EACA,wBAAA;AL+IJ;AK7IE;EACE,eAAA;EACA,kBAAA;AL+IJ;AK5IE;EACE,gBAAA;AL8IJ;AK5IE;EACE;IACE,WAjBU;IAkBV,YAlBU;ELgKd;AACF;AK3IE;EACE;IACE,WAxBU;IAyBV,YAzBU;IA0BV,mBA3BE;ELwKN;AACF;;AKzIA;EACE,gBAAA;AL4IF;;AKzIA;EACE,kBAAA;AL4IF;;AKxIE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AL2IJ;;AKxIA;EACE,oBAAA;AL2IF;;AM3LA;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;AN8LJ;AM5LI;EACI,sBAAA;EACA,SAAA;AN8LR;;AM1LA;EACI,kCAAA;EAAA,6BAAA;AN6LJ;AM3LI;EACI,YAAA;AN6LR","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.font-weight-bold {\n  font-weight: bold;\n}\n","body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n.font-weight-bold {\n  font-weight: bold;\n}\n\n/* Loading spinner animation */\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.loading-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  opacity: 0.5;\n}\n\n.loading {\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007aff;\n  animation: spin 1s linear infinite;\n}\n\n.bg-container {\n  position: fixed;\n  min-width: 100%;\n  min-height: 100%;\n}\n\n.bg-container img {\n  position: absolute;\n  /*z-index: 1;*/\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.form-auth-wrapper {\n  max-width: 440px;\n  margin: 0 auto;\n  min-height: 50vh;\n}\n.form-auth-wrapper .title {\n  font-size: 36px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n@media (max-width: 991px) {\n  .form-auth-wrapper .title {\n    font-size: 24px;\n  }\n}\n.form-auth-wrapper label {\n  font-size: 18px;\n  font-weight: 600;\n}\n@media (max-width: 991px) {\n  .form-auth-wrapper label {\n    font-size: 16px;\n  }\n}\n.form-auth-wrapper input {\n  border: 1px solid white;\n  border-radius: 4px;\n  background-color: transparent;\n  color: white;\n  padding: 10px 20px;\n}\n.form-auth-wrapper input:focus {\n  background-color: transparent;\n  border: 1px solid white;\n  caret-color: white;\n}\n.form-auth-wrapper .form-control {\n  color: white;\n}\n.form-auth-wrapper .form-auth-checkbox input[type=checkbox] {\n  border-radius: 0;\n  padding: 4px;\n}\n.form-auth-wrapper .form-auth-checkbox input[type=checkbox]:checked {\n  background-color: transparent;\n  border-color: orange;\n}\n.form-auth-wrapper .form-auth-checkbox label {\n  font-size: 14px;\n  font-weight: 400;\n  color: #9e9e9e;\n}\n.form-auth-wrapper a {\n  color: rgba(1, 157, 209, 0.9019607843);\n  transition: 0.2s ease-in-out;\n}\n.form-auth-wrapper a:hover {\n  color: orange;\n}\n.form-auth-wrapper .form-auth-btn {\n  width: 100%;\n  color: white;\n  padding: 10px 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 30px;\n  background-color: #019dd1;\n  transition: 0.2s ease-in-out;\n}\n@media (max-width: 991px) {\n  .form-auth-wrapper .form-auth-btn {\n    font-size: 16px;\n  }\n}\n.form-auth-wrapper .form-auth-btn:hover {\n  background-color: orange;\n}\n\n.not_found_container {\n  padding-top: 50px;\n  justify-content: center;\n  display: grid;\n}\n\n.profile-container {\n  padding: 20px;\n}\n.profile-container .title {\n  font-weight: bolder;\n  border-bottom-width: 1px;\n}\n.profile-container .text-right {\n  text-align: end;\n  margin-right: 20px;\n}\n.profile-container .content-card {\n  font-weight: 500;\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .profile-container .avatar-dimension {\n    width: 70px;\n    height: 70px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .profile-container .avatar-dimension {\n    width: 70px;\n    height: 70px;\n    margin-bottom: 10px;\n  }\n}\n\n.mt-5 {\n  margin-top: 3rem;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.mfa-title {\n  font-size: 30px;\n  font-weight: bold;\n  margin: 0 16px 24px;\n}\n\n.mr-2 {\n  margin-right: 0.5rem;\n}\n\n.custom-checkbox-container {\n  padding: 10px;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n}\n.custom-checkbox-container .ant-checkbox-group {\n  flex-direction: column;\n  gap: 10px;\n}\n\n.custom-modal-width {\n  width: fit-content !important;\n}\n.custom-modal-width .ant-modal-content {\n  width: 800px;\n}","/* Loading spinner animation */\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  opacity: 0.5;\n}\n\n.loading {\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007aff;\n  animation: spin 1s linear infinite;\n}",".bg-container {\n  position: fixed;\n  min-width: 100%;\n  min-height: 100%;\n}\n.bg-container img {\n  position: absolute;\n  /*z-index: 1;*/\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n",".form-auth-wrapper {\n    max-width: 440px;\n    margin: 0 auto;\n    min-height: 50vh;\n\n    .title {\n        font-size: 36px;\n        font-weight: 700;\n        margin-bottom: 20px;\n\n        @media (max-width: 991px) {\n            font-size: 24px;\n        }\n    }\n\n    label {\n        font-size: 18px;\n        font-weight: 600;\n\n        @media (max-width: 991px) {\n            font-size: 16px;\n        }\n    }\n\n    input {\n        border: 1px solid white;\n        border-radius: 4px;\n        background-color: transparent;\n        color: white;\n        padding: 10px 20px;\n\n        &:focus {\n            background-color: transparent;\n            border: 1px solid white;\n            caret-color: white;\n        }\n    }\n\n    .form-control {\n        color: white;\n    }\n\n    .form-auth-checkbox {\n        input[type=\"checkbox\"] {\n            border-radius: 0;\n            padding: 4px;\n\n            &:checked {\n                background-color: transparent;\n                border-color: orange;\n            }\n        }\n\n        label {\n            font-size: 14px;\n            font-weight: 400;\n            color: #9e9e9e;\n        }\n    }\n\n    a {\n        color: #019dd1e6;\n        transition: .2s ease-in-out;\n\n        &:hover {\n            color: orange;\n        }\n    }\n\n    .form-auth-btn {\n        width: 100%;\n        color: white;\n        padding: 10px 0;\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 30px;\n        background-color: #019dd1;\n        transition: .2s ease-in-out;\n\n        @media (max-width: 991px) {\n            font-size: 16px;\n        }\n\n        &:hover {\n            background-color: orange;\n        }\n    }\n}",".not_found_container {\n  padding-top: 50px;\n  justify-content: center;\n  display: grid;\n\n}","$mb-10: 10px;\n$img_dimension: 70px;\n.profile-container {\n  padding: 20px;\n  .title {\n    font-weight: bolder;\n    border-bottom-width: 1px;\n  }\n  .text-right {\n    text-align: end;\n    margin-right: 20px;\n  }\n\n  .content-card {\n    font-weight: 500;\n  }\n  @media only screen and (min-width: 768px) and (max-width: 1024px) {\n    .avatar-dimension {\n      width: $img_dimension;\n      height: $img_dimension;\n    }\n  }\n\n  @media only screen and (max-width: 767px) {\n    .avatar-dimension {\n      width: $img_dimension;\n      height: $img_dimension;\n      margin-bottom: $mb-10;\n    }\n  }\n}\n\n.mt-5 {\n  margin-top: 3rem;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.mfa {\n  &-title {\n    font-size: 30px;\n    font-weight: bold;\n    margin: 0 16px 24px;\n  }\n}\n.mr-2 {\n  margin-right: 0.5rem;\n}\n",".custom-checkbox-container {\n    padding: 10px;\n    border: 1px solid #d9d9d9;\n    border-radius: 6px;\n\n    .ant-checkbox-group {\n        flex-direction: column;\n        gap: 10px;\n    }\n}\n\n.custom-modal-width {\n    width: fit-content !important;\n\n    .ant-modal-content {\n        width: 800px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
